import CrossSellGalleryElementMetaData from './CrossSellGalleryElementMetaData';
import * as Colors from 'material-ui/styles/colors';

const presets = [
  {
    type: CrossSellGalleryElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 800,
      height: 350
    },
    data: {
      compProps: {
        color: Colors.grey700,
        fontSize: 14,
        fontStyle: 'normal',
        textAlign: 'center',
        textDecoration: 'none',
        fontFamily: 'Roboto',
        minFontSize: 10,
        maxFontSize: 100,
      },
    },
    hidden: false
  }
];

export default presets;
